import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormElementViewModel, IFormElementViewModel, IFormElementViewModelOptions } from '../forms';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss']
})
export class FormCheckboxComponent implements OnInit {

  @Input() vm: IFormCheckboxViewModel;

  @Output() checkChanged = new EventEmitter<IFormCheckboxChangedArg>();

  checked: boolean;
  validationErrors: string[] = [];

  /**
   *
   */
  constructor() { }

  /**
   *
   */
  ngOnInit() {
    if (!this.vm) {
      this.validationErrors = ['no view model'];
      return;
    }

    this.checked = this.vm.dataGet();
    this.validationErrors = this.vm.validate(this.vm);
  }

  /**
   *
   * @param e
   */
  modelChanged(checked: boolean) {
    if (this.vm) {
      this.vm.dataSet(checked);
    }
    
    this.checked = checked;
    this.validationErrors = this.vm.validate(this.vm);

    this.checkChanged.emit({ sender: this, errors: this.validationErrors, checked: checked });
  }

  /**
   * 
   * @param context 
   * @param field 
   * @param options
   * @param elementInstance 
   * @returns 
   */
   public static viewModel(context: any, field: string, options: IFormCheckboxOptions, elementInstance: number = undefined): IFormCheckboxViewModel {
    const ret: IFormCheckboxViewModel = {
      ...FormElementViewModel.create(context, field, options, elementInstance),

      validate: (vm: IFormCheckboxViewModel) => {
        const errors: string[] = [];
        return errors.filter(e => e);
      }
    };
    return ret;
  }  

}

/**
 *
 */
export interface IFormCheckboxChangedArg {
  sender: FormCheckboxComponent;
  errors: string[];
  checked: boolean;
}

/**
 *
 */
export interface IFormCheckboxViewModel extends IFormElementViewModel, IFormCheckboxOptions {
}


/**
 * 
 */
export interface IFormCheckboxOptions extends IFormElementViewModelOptions {
   
}